export const minmax = (min: number, max: number, limit?: number) => {
  return Math.min(Math.max(limit || max, min), max);
};
